<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Commission Withdraw</h1>
    <commissionWithdraw />
  </v-card>
</template>

<script>
import userTable from "@/components/back-office/ManagerUserManage/UserTable.vue";
import commissionWithdraw from "@/components/back-office/ManagerUserManage/WithdrawCommission.vue";
import { mapState } from "vuex";
export default {
  components: {
    commissionWithdraw,
  },
  computed: {
    ...mapState({
      recentPath: (state) => state.backOffice.recentRoutePath,
    }),
  },
  destroyed() {
    this.$store.commit("fetchUserBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Manager management",
        disabled: true,
        href: "/weserve_admin_login/control/-/manager-manage",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style></style>
